import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  Renderer2,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { ReportlinksserviceService } from "src/app/user/reportlinks/reportlinksservice.service";
import { FormsModule } from "@angular/forms";
import { AnalysisService } from "src/app/shared/services/analysis.service";


@Component({
    selector: "app-review-workflow",
    templateUrl: "./review-workflow.component.html",
    styleUrls: ["./review-workflow.component.scss"],
    standalone: false
})
export class ReviewWorkflowComponent implements OnInit {
  @Input() activity: any; // receive data from parent
  @Input() reportTemplateId: any;
  @Input() instancedetailid:any
  @Output() back = new EventEmitter<void>();

  datasets: any[] = [];
  getdata: any = [];
  UserRolesWithRoleId: any[];
  selectedDataset: any = null;
  backgroundColorScreen = "";
  backgroundColorButton = "";
  assessmentNotes: string = "";
  signalDetected: string = "no";
  attachedFiles: File[] = [];
  reviewComments: string = "";
  delayReason: string = "";
  activeComponent: 'history' | 'upcoming' = 'history'; // default
  activeSection: 'report' | 'analysis' = 'report'; // default show Report
   showReportAnalysis: boolean = true; // default view
showAlertSummary:boolean=false;
backToScreen:any;

allSheets: any = {};
sheetNames: string[] = [];
selectedSheet = '';
rowData: any[] = [];
columnDefs: any[] = [];

  constructor(
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private router: Router,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private jsignalsService: JsignalService,
    private linkservice: ReportlinksserviceService,
    private service: ReportingServiceService,
    private analysisService : AnalysisService
  ) {}

  ngOnInit(): void {
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    console.log("schedule id", this.activity.scheduleId);
    if(this.activity.reviewActivityType == "Quantitative"){
      this.showAlertSummary=true;
      this.showReportAnalysis=false
    }else{
      this.showAlertSummary=false;
      this.showReportAnalysis=true;
      
      
    }
  }

  
  goBack() {
    this.back.emit();
  }

  openAnalysis(selectedDataset: any) {
    console.log("Opening analysis view...");
    // Select dataset added Into data To Match The Common Analysis Method to generate QuickSight
    const data = {
      rowData: selectedDataset,
    };
    // Selected Dataset added Inside rowData
    console.log("Simulated row data:", data);
    console.log("Report Creation ID:", data.rowData.reportcreationid);

    // Passing the data to analysis to generate quicksight
    this.analysisService.analysis(data);
  }

  onSubmitReview() {
    console.log("Inside Submit Method ");
    // TODO: trigger review flow
  }

  onGenerateReport() {
    console.log("Inside Generate Report ");
  }


  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.attachedFiles.push(files.item(i)!);
    }
  }

  removeFile(file: File) {
    const index = this.attachedFiles.indexOf(file);
    if (index >= 0) {
      this.attachedFiles.splice(index, 1);
    }
  }
   showHistory() {
    this.activeComponent = 'history';
  }

  showUpcoming() {
    this.activeComponent = 'upcoming';
  }
  goToAssessment(){

  }
  
switchSection(section: 'report' | 'analysis') {
  this.activeSection = section;
}

  openAssessment(event) {
    console.log(event);
    this.backToScreen=event;
    this.showReportAnalysis = false;
    this.showAlertSummary=false;
  }

  submitAssessment() {
    console.log('Assessment submitted');
    this.back.emit();
    // handle submit logic
  }
  backToReports(){
    if(this.backToScreen=="AlertSummary"){
       this.showAlertSummary=true;
       this.showReportAnalysis = false;
    }else{
       this.showAlertSummary=false;
       this.showReportAnalysis = true;
    }
  }

}
